export default __webpack_public_path__ + "static/media/nodejs.214246b8.png";